import { render } from "./modalConfirmTransaction.vue?vue&type=template&id=fe39c11a&scoped=true"
import script from "./modalConfirmTransaction.vue?vue&type=script&lang=js"
export * from "./modalConfirmTransaction.vue?vue&type=script&lang=js"

import "./modalConfirmTransaction.vue?vue&type=style&index=0&id=fe39c11a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe39c11a"]])

export default __exports__